import { useMemo } from "react";
import { notEqualValues, required } from "../../../../../../helpers/forms/validate.js";
import useSearcherDestinationInput from "../../../../../../hooks/common/searchers/inputs/useDestinationInput.js";
import useValue from "../../../../../../hooks/forms/useValue.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../../context/index.js";
import useSearcherFlightHotelDefaultValues from "../../hooks/useSearcherFlightHotelDefaultValues.js";
const useDestinationInput = ()=>{
    const props = useSearcherFlightHotelProps();
    const { destination , config  } = props ?? {};
    const { literals  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { isLoading , destinationAirport  } = state ?? {};
    const defaultValues = useSearcherFlightHotelDefaultValues(props);
    const originValue = useValue({
        name: 'origin'
    });
    const originDestinationNotEqualValidation = useMemo(()=>[
            required(),
            notEqualValues(originValue?.value, destinationAirport?.code)
        ], [
        destinationAirport?.code,
        originValue?.value
    ]);
    return useSearcherDestinationInput({
        ...destination,
        types: destination?.types ?? [
            'ISL',
            'CIU',
            'ZON',
            'HOT'
        ],
        disabled: isLoading,
        validate: originDestinationNotEqualValidation,
        label: literals?.destinationLabel ?? '',
        defaultValue: defaultValues.destination,
        queryParams: {
            p: destination?.operator?.toLowerCase() ?? 'or',
            o: destination?.codes?.join(',') ?? 'PAK',
            n: destination?.limit ?? 20
        }
    });
};
export default useDestinationInput;

//# sourceMappingURL=useDestinationInput.js.map